"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _index = require("../../EXPERIMENTAL_Select/index");

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var VerbAtom = function VerbAtom(_ref) {
  var disabled = _ref.disabled,
      _onChange = _ref.onChange,
      verb = _ref.verb,
      verbOptions = _ref.verbOptions;
  var value = verbOptions.find(function (option) {
    return option.value === verb;
  });
  return _react2.default.createElement("div", {
    className: "mh3 pb3 flex items-center",
    style: verbOptions.length !== 1 ? {
      minWidth: '20%'
    } : {}
  }, verbOptions.length !== 1 ? _react2.default.createElement("div", {
    className: "flex-auto"
  }, _react2.default.createElement(_index2.default, {
    clearable: false,
    disabled: disabled,
    multi: false,
    onChange: function onChange(option) {
      return _onChange(option && option.value);
    },
    options: verbOptions,
    placeholder: "",
    value: value
  })) : _react2.default.createElement("span", {
    className: "pt3"
  }, value.label));
};

exports.default = VerbAtom;